<template>
  <div class="flight-pad-details-bags">
    <div>
      <div class="h5 mb-0 semibold">
        {{ title }}
        <span v-if="show_branded_fare">{{ branded_fare }}</span>
      </div>
      <p class="flight-pad-details-bags__description" v-html="description"></p>
    </div>
    <div>
      <div class="flight-pad-details-bags__title">
        <vb-icon name="backpack" :size="20" />
        <span>
          {{ hand_bags }}
          Bagagli{{ hand_bags === 1 ? 'o' : '' }} personal{{
            hand_bags === 1 ? 'e' : 'i'
          }}
        </span>
      </div>
      <p class="flight-pad-details-bags__subscription">
        Piccolo, va sotto il sedile. Per ogni passeggero adulto.
      </p>
    </div>
    <div v-if="show_cabin_bags">
      <div class="flight-pad-details-bags__title">
        <vb-icon name="trolley" :size="25" />
        <span>
          <template v-if="shows_included_cabin_bags">{{ cabin_bags }} </template>Bagagli{{ shows_included_cabin_bags && cabin_bags === 1 ? 'o' : '' }}
          a mano
        </span>
      </div>
      <p
        v-if="shows_included_cabin_bags"
        class="flight-pad-details-bags__subscription"
      >
        Sopra la testa nello scomparto. Per ogni passeggero adulto.
      </p>
      <p v-else class="flight-pad-details-bags__subscription">
        Controlla nella descrizione della tariffa
        <span v-if="!is_results_route">{{
          branded_fare || 'che hai selezionato'
        }}</span>
        quanti bagagli a mano sono inclusi.
      </p>
    </div>
    <div>
      <div class="flight-pad-details-bags__title">
        <vb-icon name="luggage" :size="30" />
        <span>
          {{ luggage_bags }}
          Bagagli{{ luggage_bags === 1 ? 'o' : '' }} da stiva
        </span>
      </div>
      <p class="flight-pad-details-bags__subscription">
        Si consegna al check-in e viaggia in stiva. È il numero di bagagli in
        stiva inclusi per ogni passeggero adulto.
      </p>
    </div>
  </div>
</template>

<script>
  import {
    hand_bags_per_adult,
    luggage_bags_per_adult,
    cabin_bags_per_adult,
  } from '../script/utilities';
  import { capitalize } from '@liveflight/utilities';
  import {
    has_capability_for,
    get_branded_fare_label,
  } from '@liveflight/providers';

  export default {
    name: 'flight-pad-details-bags',
    props: {
      flight_offer: {
        type: Object,
        default: () => ({}),
      },
      // titolo della sezione bagagli; default = copy storico
      title: {
        type: String,
        default: 'Bagagli inclusi nella tariffa',
      },
      // descrizione introduttiva (supporta markup); default = copy storico
      description: {
        type: String,
        default:
          'Per ogni passeggero adulto. Verifica nel box <span class="semibold">La tua scelta</span> il numero complessivo dei bagagli inclusi e se sono inclusi anche per bambini e neonati. Verifica sempre le condizioni e le franchigie sul sito della compagnia aerea. Il conteggio non considera i bagagli aggiuntivi acquistati.',
      },
    },
    computed: {
      hand_bags() {
        return hand_bags_per_adult(this.flight_offer);
      },
      luggage_bags() {
        return luggage_bags_per_adult(this.flight_offer);
      },
      cabin_bags() {
        return cabin_bags_per_adult(this.flight_offer);
      },
      shows_included_cabin_bags() {
        return has_capability_for(this.flight_offer, 'showIncludedCabinBags');
      },
      flight_offer_has_upsell() {
        try {
          return this.$store.state.liveflight.flight_offer_has_upsell;
        } catch {
          return false;
        }
      },
      branded_fare() {
        return this.capitalize(get_branded_fare_label(this.flight_offer));
      },
      is_results_route() {
        return this.$route.name === 'results';
      },
      show_branded_fare() {
        return !this.is_results_route && Boolean(this.branded_fare);
      },
      show_cabin_bags() {
        try {
          // Kyte carries an explicit includedCabinBags count; always show.
          // Amadeus falls back to a branded-fare heuristic.
          if (this.shows_included_cabin_bags) return true;
          if (this.is_results_route) {
            return this.branded_fare.length;
          }
          return this.flight_offer_has_upsell && this.branded_fare.length;
        } catch {
          return false;
        }
      },
    },
    methods: {
      capitalize,
    },
  };
</script>

<style lang="scss" scoped>
  .flight-pad-details-bags {
    line-height: unset;
    padding: $grid-gutter-width 0 $grid-gutter-20 0;
    display: flex;
    flex-direction: column;
    gap: $grid-gutter-width / 2;

    &__description {
      color: $gray-900;
      margin: 0;
      margin-top: $grid-gutter-width / 3;
      font-size: $font-size-md;
    }

    &__subscription {
      font-size: $font-size-sm;
      color: $gray-700;
      margin: 0;
      margin-top: $grid-gutter-width / 5;
    }

    &__title {
      line-height: unset;
      &__icon {
        line-height: normal;
      }
      font-size: 16px;
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
</style>
